const SERVICE = 'file-service'

const getFileApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/file', params)

const uploadFilesApi = async (api, body) => api.setService(SERVICE).client.request({
  method: 'POST',
  data: body,
  url: `${api.service}/file`,
  headers: {
    ...api.optionsObject.headers,
    'Content-Type': 'multipart/form-data',
  },
})

module.exports = {
  getFileApi,
  uploadFilesApi,
}
